import { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, FormControl, InputLabel, Select, MenuItem,
} from '@mui/material';
import type { CreateJournalPayload } from '../../types/api.types';

const LANGUAGES = [
  'Arabic', 'Chinese (Mandarin)', 'Dutch', 'English', 'French', 'German',
  'Hindi', 'Italian', 'Japanese', 'Korean', 'Polish', 'Portuguese',
  'Russian', 'Spanish', 'Swedish', 'Turkish', 'Vietnamese',
];

interface Props {
  open: boolean;
  onClose: () => void;
  onSubmit: (payload: CreateJournalPayload) => void;
  isLoading?: boolean;
}

export const JournalCreateModal = ({ open, onClose, onSubmit, isLoading }: Props) => {
  const [name, setName] = useState('');
  const [learningLanguage, setLearningLanguage] = useState('');
  const [nativeLanguage, setNativeLanguage] = useState('');

  const handleSubmit = () => {
    if (!name.trim() || !learningLanguage || !nativeLanguage) return;
    onSubmit({ name: name.trim(), learningLanguage, nativeLanguage });
  };

  const handleClose = () => {
    setName('');
    setLearningLanguage('');
    setNativeLanguage('');
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create Journal</DialogTitle>
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
        <TextField
          label="Journal Name"
          value={name}
          onChange={e => setName(e.target.value)}
          fullWidth
          autoFocus
        />
        <FormControl fullWidth>
          <InputLabel>Language I'm Learning</InputLabel>
          <Select value={learningLanguage} label="Language I'm Learning" onChange={e => setLearningLanguage(e.target.value)}>
            {LANGUAGES.map(l => <MenuItem key={l} value={l}>{l}</MenuItem>)}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel>My Native Language</InputLabel>
          <Select value={nativeLanguage} label="My Native Language" onChange={e => setNativeLanguage(e.target.value)}>
            {LANGUAGES.map(l => <MenuItem key={l} value={l}>{l}</MenuItem>)}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!name.trim() || !learningLanguage || !nativeLanguage || isLoading}
        >
          Create
        </Button>
      </DialogActions>
    </Dialog>
  );
};
